export default __webpack_public_path__ + "static/media/26-color.e9059cc5.svg";